import { UPDATE_EXERCISE } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_EXERCISE.LOAD:
      return {
        ...state,
        loading: true
      };
    case UPDATE_EXERCISE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case UPDATE_EXERCISE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
